// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expanded {
  height: 30px;
}

.selected {
  background-color: #eee;
  font-weight: bold;
}

.no-ds {
  margin-left: 15px;
  font-family: Roboto, "Helvetica Neue", sans-serif;
  font-size: 11pt;
}

mat-list-item {
  border-radius: 30px;
}

mat-list-item:hover {
  background-color: #F5F5F5;
  border-radius: 30px;
}

.dataset-list {
  padding: 0;
}

.list-item {
  cursor: pointer;
}

.dataset-item {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  font-size: 11pt;
}

.list-item .dataset-item .delete-button {
  visibility: hidden;
  cursor: pointer;
  margin-right: 0;
}

.list-item:hover .dataset-item .delete-button {
  visibility: visible;
}

.schedule-cell .not-executable {
  opacity: 0.3;
  font-size: 11px;
}
.schedule-cell .schedule-button {
  min-width: unset;
  padding: 4px 8px;
  font-size: 12px;
  line-height: 1.2;
  height: auto;
}
.schedule-cell .schedule-button mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  margin-right: 4px;
  opacity: 0.5;
}
.schedule-cell .schedule-button code {
  font-family: monospace;
  font-size: 11px;
  background: rgba(0, 0, 0, 0.1);
  padding: 2px 6px;
  border-radius: 3px;
}
.schedule-cell .schedule-button .no-schedule {
  opacity: 0.5;
  font-size: 11px;
}
.schedule-cell .schedule-button.has-schedule mat-icon {
  opacity: 1;
  color: var(--preset-primary, #2aa198);
}

.delete-btn {
  --square-button-size: 24px;
  --square-icon-size: 14px;
  opacity: 0;
  transition: opacity 0.15s ease;
}
.delete-btn:hover {
  opacity: 1;
  color: #e53935;
}

tr:hover .delete-btn {
  opacity: 0.5;
}

.mat-column-actions {
  width: 40px;
  text-align: center;
}

.cron-editor-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/jobs-widget/jobs-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,sBAAA;EACA,iBAAA;AACF;;AAEA;EACE,iBAAA;EACA,iDAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,yBAAA;EACA,mBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAIE;EACE,YAAA;EACA,eAAA;AADJ;AAIE;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AAFJ;AAII;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;AAFN;AAKI;EACE,sBAAA;EACA,eAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;AAHN;AAMI;EACE,YAAA;EACA,eAAA;AAJN;AAQM;EACE,UAAA;EACA,qCAAA;AANR;;AAaA;EACE,0BAAA;EACA,wBAAA;EACA,UAAA;EACA,8BAAA;AAVF;AAYE;EACE,UAAA;EACA,cAAA;AAVJ;;AAcA;EACE,YAAA;AAXF;;AAeA;EACE,WAAA;EACA,kBAAA;AAZF;;AAgBA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAbF","sourcesContent":[".expanded {\n  height: 30px;\n}\n\n.selected {\n  background-color: #eee;\n  font-weight: bold;\n}\n\n.no-ds {\n  margin-left: 15px;\n  font-family: Roboto, \"Helvetica Neue\", sans-serif;\n  font-size: 11pt;\n}\n\nmat-list-item {\n  border-radius: 30px;\n}\n\nmat-list-item:hover {\n  background-color: #F5F5F5;\n  border-radius: 30px;\n}\n\n.dataset-list {\n  padding: 0;\n}\n\n.list-item {\n  cursor: pointer\n}\n\n.dataset-item {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 11pt;\n}\n\n.list-item .dataset-item .delete-button {\n  visibility: hidden;\n  cursor: pointer;\n  margin-right: 0;\n}\n\n.list-item:hover .dataset-item .delete-button{\n  visibility: visible;\n}\n\n// Schedule column styles\n.schedule-cell {\n  .not-executable {\n    opacity: 0.3;\n    font-size: 11px;\n  }\n\n  .schedule-button {\n    min-width: unset;\n    padding: 4px 8px;\n    font-size: 12px;\n    line-height: 1.2;\n    height: auto;\n\n    mat-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n      margin-right: 4px;\n      opacity: 0.5;\n    }\n\n    code {\n      font-family: monospace;\n      font-size: 11px;\n      background: rgba(0, 0, 0, 0.1);\n      padding: 2px 6px;\n      border-radius: 3px;\n    }\n\n    .no-schedule {\n      opacity: 0.5;\n      font-size: 11px;\n    }\n\n    &.has-schedule {\n      mat-icon {\n        opacity: 1;\n        color: var(--preset-primary, #2aa198);\n      }\n    }\n  }\n}\n\n// Delete button\n.delete-btn {\n  --square-button-size: 24px;\n  --square-icon-size: 14px;\n  opacity: 0;\n  transition: opacity 0.15s ease;\n\n  &:hover {\n    opacity: 1;\n    color: #e53935;\n  }\n}\n\ntr:hover .delete-btn {\n  opacity: 0.5;\n}\n\n// Actions column - minimal width\n.mat-column-actions {\n  width: 40px;\n  text-align: center;\n}\n\n// Cron editor overlay\n.cron-editor-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
